import React, { useCallback, useEffect, useRef } from 'react';
import { RushRulesDialog } from '@colonist/clientforge';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
import { sendRushRulesPopupDismissed, sendRushRulesPopupShown, sendRushRulesPopupStartGameClicked, sendRushRulesPopupVideoClicked } from '../analytics/sendRushRulesPopupAnalytic.ts';
export const RushRulesDialogContainer = ({ open, onClose, onConfirm })=>{
    const handledRef = useRef(false);
    useEffect(()=>{
        if (!open) return;
        // The dialog view is reused across opens, so reset the handled flag each time it reopens
        handledRef.current = false;
        sendRushRulesPopupShown();
    }, [
        open
    ]);
    const handleConfirm = useCallback(()=>{
        handledRef.current = true;
        sendRushRulesPopupStartGameClicked();
        onClose();
        onConfirm();
    }, [
        onClose,
        onConfirm
    ]);
    const handleClose = useCallback(()=>{
        if (!handledRef.current) sendRushRulesPopupDismissed();
        onClose();
    }, [
        onClose
    ]);
    const handleExternalClick = useCallback((url)=>{
        sendRushRulesPopupVideoClicked();
        navigateToPage(url, true);
    }, []);
    return /*#__PURE__*/ React.createElement(RushRulesDialog, {
        open: open,
        showVideo: !UIUtilsEjsVariables.isUserOnDiscord,
        onExternalClick: handleExternalClick,
        onClose: handleClose,
        onConfirm: handleConfirm
    });
};
